import { styled } from '@mui/material/styles';
import { Box, alpha } from '@mui/material';
import { FilterDropdown } from 'views/rebranded-module/common/components/UI/FilterDropdown';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .DVListAndFilter': {
    position: 'relative',
    paddingTop: theme.spacing(8),
    [theme.breakpoints.down('lg')]: {
      paddingTop: theme.spacing(3.5),
    },
  },
  '& .DVFilterDropdownContainer': {
    display: 'flex',
    justifyContent: 'end',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  '& .DVFilterAndListContainer': {
    position: 'relative',
    zIndex: 2,
    paddingBottom: theme.spacing(14),
  },
  '& .DVCustomContainer': {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    [theme.breakpoints.down('lg')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  '& .DVBGPattern': {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: theme.typography.pxToRem(205),
    zIndex: 1,
    maskImage: `linear-gradient(
        to bottom,
         ${alpha(theme.palette.common.black, 0.1)} 50%,
         ${alpha(theme.palette.common.black, 0.01)} 100%
      )`,
  },
}));

export const StyledFilterDropdown = styled(FilterDropdown)(({ theme }) => ({
  '& .FDSelectInput': {
    border: `1px solid ${theme.palette.divider[7]} !important`,
    paddingRight: 0,
    borderRadius: `${theme.spacing(0.5)} !important`,
    [theme.breakpoints.up('md')]: {
      width: `${theme.typography.pxToRem(370)} !important`,
    },
    '& .MuiSelect-select': {
      padding: `${theme.spacing(2.25, 3, 1.75, 6)} !important`,
      '& .MuiTypography-root': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      },
    },
    '& .DVMapIcon': {
      left: theme.spacing(2),
    },
    '& .DVArrowIcon': {
      left: 'unset',
      right: theme.spacing(0),
      top: '50%',
      bottom: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
}));

export default StyledBox;
